import { createLoggerFactory } from './logger.js';
export default createLoggerFactory({ transports: [] });
